import { useState, useEffect, useCallback } from 'react'

interface UseCopyToClipboardReturn {
    copy: (text: string) => void
    toastVisible: boolean
    toastMessage: string
    hideToast: () => void
}

export const useCopyToClipboard = (
    timeoutMs = 3000
): UseCopyToClipboardReturn => {
    const [toastVisible, setToastVisible] = useState(false)
    const [toastMessage, setToastMessage] = useState('')

    const copy = useCallback((text: string) => {
        navigator.clipboard.writeText(text).then(
            () => {
                setToastMessage('Скопировано в буфер обмена')
                setToastVisible(true)
            },
            () => {
                setToastMessage('Не удалось скопировать ссылку.')
                setToastVisible(true)
            }
        )
    }, [])

    const hideToast = useCallback(() => {
        setToastVisible(false)
    }, [])

    useEffect(() => {
        if (toastVisible) {
            const timer = setTimeout(() => {
                setToastVisible(false)
            }, timeoutMs)

            return () => clearTimeout(timer)
        }
    }, [toastVisible, timeoutMs])

    return { copy, toastVisible, toastMessage, hideToast }
}
